import React from 'react';
import { Divider } from 'semantic-ui-react'

const ConfTar1 = ({styles, handleClickRegr, handleCSV}) => {
  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleCSV(ev)}>
        <i className="large newspaper outline violet icon"></i>
        Generar archivo CSV
      </button>

      <Divider inverted />

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default ConfTar1
